import { createAction } from '@ngrx/store';

const routeStart = createAction('[App Loading] Start route loading');
const routeEnd = createAction('[App Loading] End route loading');

export const LoadingActions = {
  routeStart,
  routeEnd,
};
